import { Build, getAssetPath } from '@stencil/core';

export const getAssetByPath = (fileName: string) => {
  if (Build.isDev) {
    return getAssetPath(fileName);
  }
  if (Build.isServer) {
    return REPLACE_CARPENTRY_API + getAssetPath(`/dist/carpentry/${fileName}`);
  }
  return getAssetPath(`/dist/carpentry/${fileName}`);
};
